import { Component, OnInit, Input, TemplateRef} from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { CommonService } from './../../services/global/common.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MessageService } from '../../services/global/message.service';
import { ApiService } from '../../services/global/api.service';
import { AuthService } from '../../services/global/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { Md5 } from 'ts-md5/dist/md5';

import { AutoITRService } from 'app/shared/services/global/auto.itr.service';



@Component({
	selector: 'app-header-side',
	templateUrl: './header-side.template.html',
})
export class HeaderSideComponent implements OnInit {
	@Input() notificPanel;

	public layoutConf: any;
	nameIcon = '';
	ssoNameIcon = '';
	constructor(public layout: LayoutService, 
		public translate: TranslateService, 
		public common: CommonService, 
		public router: Router,
		public message: MessageService,
		public cookieService: CookieService,
		public api: ApiService,
		public autoItrService: AutoITRService,
		public auth: AuthService) {
	}

	ngOnInit() {
		this.layoutConf = this.layout.layoutConf;
		this.nameIcon = this.common.partyName.split('')[0];
		this.nameIcon.toUpperCase();
		this.ssoNameIcon = this.common.loginUserFirstName.split('')[0];
	}

	toggleNotific() {
		this.notificPanel.toggle();
	}

	toggleSidenav() {
		if (this.layoutConf.sidebarStyle === 'closed') {
			return this.layout.publishLayoutChange({
				sidebarStyle: 'full',
			});
		}
		this.layout.publishLayoutChange({
			sidebarStyle: 'closed',
		});
	}

	openCustomerPortal()      {
		this.router.navigateByUrl('/dashboard');
	}

	logoutFromSSO() {
		const http_x_auth = this.cookieService.get('preserveKey');
		const client_secret_id_md5 = Md5.hashStr(`${this.api.client_secret}|${this.api.client_id}|`);
		const app_key_base_64 = btoa(`${client_secret_id_md5}|${http_x_auth}`);
		const data = {
			app_name: 'tax.hostbooks.com',
			appKey: app_key_base_64,
			preserveKey: http_x_auth,
			action: 'logout'
		};
		console.log(data);
		this.message.loading = true;
		this.api.ssoAuth(`sso/access`, data).subscribe(
			res => {
				console.log('Logout Res ', res);
				this.message.loading = false;
				const finalData = JSON.parse(res['data']);
				if (finalData['message'] === 'Logout Successfully' || finalData['message'] === 'Your session has been already expired') {
					this.auth.token = null;
					localStorage.clear();
					this.cookieService.deleteAll();
					window.location.href = this.auth.ssoLoginURL;
				} else {
					this.message.displayErrorToaster(finalData['message']);
					this.message.loading = false;
					this.router.navigateByUrl('/dashboard');
				}
			},
			err => {
				console.log('LogOut Err ', err);
				this.message.loading = false;
				this.message.displayErrorToaster('Unable to logout!');
				this.router.navigateByUrl('/dashboard');
			}
		);
	}

	toggleCollapse() {
		if (this.layoutConf.sidebarStyle === 'compact') {
			return this.layout.publishLayoutChange(
				{
					sidebarStyle: 'full',
					sidebarCompactToggle: false,
				},
				{ transitionClass: true }
			);
		}
		this.layout.publishLayoutChange(
			{
				sidebarStyle: 'compact',
				sidebarCompactToggle: true,
			},
			{ transitionClass: true }
		);
	}

	openModal(template: TemplateRef<any>) {
		this.autoItrService.setModalLocation = 'header';
		this.autoItrService.partyType = this.common.partyTypeValue;
		this.autoItrService.openModal(template, 'header');
	}

}
